import { getComplianceRow } from "@thequantumhub/iam-package";

const exportCSV = (timeLabels, complianceResults) => {
  const csvData = [];

  const headerRow = ["Item", ...timeLabels, "Total Compliance %"];
  csvData.push(headerRow.join(","));

  Object.entries(complianceResults).forEach(([item, timeData]) => {
    const rowData = getComplianceRow(item, timeData, timeLabels);

    csvData.push(rowData.join(","));
  });

  const csvBlob = new Blob([csvData.join("\n")], { type: "text/csv" });

  const csvUrl = URL.createObjectURL(csvBlob);
  const link = document.createElement("a");
  link.href = csvUrl;
  link.download = "ComplianceTable.csv";
  link.click();

  URL.revokeObjectURL(csvUrl);
};

export default exportCSV;
